module.exports = __webpack_public_path__ + "static/img/5.b3683fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/5.png
// module id = a9ZD
// module chunks = 0